import { useState } from 'react'
import { CrownIcon, EverlanceIcon } from 'core/_legacy/icons'
import Drawer from 'core/components/drawer/Drawer'
import useNavigation from 'core/hooks/navigation/useNavigation'
import NavPopover from 'core/widgets/top-nav/NavPopover'
import ProfilePopover from 'core/widgets/top-nav/ProfilePopover'
import cn from 'utils/cn'
import { useUserProfile } from 'core/hooks/data/useDataHook'
import useRolesAndPermissions from 'core/hooks/user/useRolesAndPermissions'
import PublicTopNav from 'core/widgets/top-nav/PublicTopNav'
import usePathSection from 'core/hooks/navigation/usePathSection'
import MenuItems from 'core/widgets/side-menu/MenuItems'
import AiOutlineMenu from 'core/_tmp/react-icons/AiOutlineMenu'
import { useSettings } from 'core/hooks/settings/useSettings'
import useAuth from 'core/hooks/auth/useAuth'

const TopNav = () => {
  const {
    data: {
      featureFlags: { ENABLE_B2C_2 }
    }
  } = useSettings()
  const [showSideNav, setShowSideNav] = useState(false)
  const { push, pathname } = useNavigation()
  const { isTeamSpace, section } = usePathSection()
  const { isAuthenticated } = useAuth()

  const { hasOnlyRole } = useRolesAndPermissions()
  const { data: currentUser } = useUserProfile()
  const isOnlyReviewer = hasOnlyRole('isReviewer')
  const { subscription } = currentUser ?? {}

  const onInvitePage = pathname?.includes('accept-invite')

  const showTopNav = section === 'onboarding'

  if (isAuthenticated && !onInvitePage && !showTopNav) return null

  return isAuthenticated && !onInvitePage ? (
    <div className="h-[4.6rem] py-2.5 px-5 bg-white shadow-md shadow-dark-1 flex items-center justify-between mb-6 md:mb-0">
      <div className="flex items-center">
        <div
          className="lg:hidden text-dark-6 text-4xl cursor-pointer"
          onClick={() => {
            setShowSideNav(true)
          }}
        >
          <AiOutlineMenu />
        </div>

        <span
          className="cursor-pointer mx-3 md:mx-6"
          onClick={() => {
            push(
              isTeamSpace
                ? isOnlyReviewer
                  ? '/teams/compliance'
                  : '/teams'
                : '/dashboard'
            )
          }}
        >
          <EverlanceIcon />
        </span>

        <NavPopover />
      </div>
      <div className="flex items-center gap-10">
        {!subscription && (
          <div
            className={cn([
              'flex items-center gap-2',
              isTeamSpace && 'text-primary'
            ])}
            onClick={() => {
              push(isTeamSpace ? '/teams/premium' : '/premium')
            }}
          >
            {isTeamSpace ? null : pathname === '/teams/premium' ||
              pathname === '/premium' ? (
              <CrownIcon color="#31B59F" />
            ) : (
              <CrownIcon />
            )}
            <span className=" font-medium cursor-pointer">
              {isTeamSpace
                ? 'Unlock Unlimited Trips'
                : ENABLE_B2C_2
                  ? 'Explore plans'
                  : 'Unlock Premium'}
            </span>
          </div>
        )}
        <ProfilePopover />
      </div>

      <Drawer
        width="300px"
        show={showSideNav}
        onClose={() => {
          setShowSideNav(false)
        }}
        enableBackdrop
      >
        <MenuItems open />
      </Drawer>
    </div>
  ) : (
    <PublicTopNav />
  )
}

export default TopNav
